import {Button, ButtonBaseProps, Modal} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, {useContext, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {AppContext} from '../contexts/AppContextProvider'
import {OrgCustomizationContext} from "../themes/OrgCustomizationProvider";
import useScreenFlow from "../hooks/useScreenFlow";
import {cancelComplaint} from "../contexts/useComplaintReducer/RootReducerFactory";
import {resetIndexedDb} from "../lib/db";

type NextButtonProps = ButtonBaseProps & {
    before?: () => void
    increments?: number
}

type PreviousButtonProps = ButtonBaseProps & {
    screenpath?: string
    before?: () => void
}

export const NextButton: React.FC<NextButtonProps> = ({
    before,
    increments = 1,
    ...props
}) => {
    const { t } = useContext(OrgCustomizationContext)

    const handleNextClick = () => {
        if (before) before()
        window.scrollTo(0, 0)
    }

    return (
        <Button
            {...props}
            size='large'
            variant='contained'
            color='primary'
            onClick={handleNextClick}
        >
            {t('continue')}
        </Button>
    )
}

export const PreviousButton: React.FC<PreviousButtonProps> = (props) => {
    const navigate = useNavigate()
    const {navigateBackward} = useScreenFlow()
    const { t } = useContext(OrgCustomizationContext)

    const history = JSON.parse(sessionStorage.getItem('history') || '["/"]')
    
    if (history.length === 1) return null

    const handlePreviousClick = () => {
        props.before && props.before()
        !!props.screenpath ? navigate(props.screenpath) : navigateBackward()
        window.scrollTo(0, 0)
    }

    return (
        <Button
            {...props}
            size='large'
            variant='contained'
            color='secondary'
            onClick={handlePreviousClick}
        >
            {t('previous')}
        </Button>
    )
}

export const useStyles = makeStyles((theme) => ({
    divider: {
        margin: '30px 0',
    },
    totalSpan: {
        float: 'right',
        fontSize: '1.5rem',
        marginTop: '1rem',
    },
    totalP: {
        textAlign: 'right',
        display: 'block',
        size: '1.1rem',
    },
    summary: {
        display: 'grid',
        gridTemplateColumns: 'auto 50px 50px',
    },
    paper: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 350,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}))

export const CancelButton: React.FC<ButtonBaseProps> = (props) => {
    const { dispatch } = useContext(AppContext)
    const [display, setDisplay] = useState(false)
    const {navigateTo} = useScreenFlow()
    const classes = useStyles()
    const { t } = useContext(OrgCustomizationContext)

    const handleCancel = async() => {
        await resetIndexedDb()
        dispatch(cancelComplaint())
        navigateTo('/', { replace: true })
        window.scrollTo(0, 0)
    }

    return (
        <>
            <Modal
                open={display}
                onClose={() => setDisplay(false)}
                aria-labelledby='cancel-modal-title'
                aria-describedby='cancel-modal-description'
            >
                <div className={classes.paper}>
                    <p>{t('confirm_order_cancel')}</p>

                    <div
                        style={{
                            width: '100%',
                            marginTop: 30,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 15,
                        }}
                    >
                        <Button
                            color='secondary'
                            variant='contained'
                            onClick={() => setDisplay(false)}
                        >
                            {t('no_do_not_cancel_order')}
                        </Button>
                        <Button
                            color='primary'
                            variant='contained'
                            onClick={handleCancel}
                        >
                            {t('yes_cancel_complaint')}
                        </Button>
                    </div>
                </div>
            </Modal>

            <Button
                {...props}
                size='large'
                variant='contained'
                color='secondary'
                onClick={() => setDisplay(true)}
            >
                {t('cancel')}
            </Button>
        </>
    )
}
